import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { addCommonReasonAPI, addProductCarouselApi, addWalletReasonAPI, assignProductsToCarouselApi, BulkProductCategoriesUpdateApi, BulkProductUpdateAPI, createLegalAPI, createStaticPageAPI, deleteLegalAPI, deleteReasonApi, deleteStaticPageAPI, deleteWalletReasonApi, editRefundReasonApi, editWalletReasonApi, fetchAIPromptAPI, fetchAllRegionsAPI, fetchCarouselIdProductApi, fetchInfoEffectsAPI, fetchProductCategoriesAPI, fetchProductDeatilsCarouselApi, fetchRefundListAPI, fetchRefundStatusAPI, fetchRefundTableAPI, fetchWalletReasonListAPI, fetchWalletTableAPI, getBlazeStatusApi, getBlockReasonAPI, getLegalListAPI, getMediaFromLibraryApi, getPaymentPlatformStatusAPI, getProductDisclaimersAPI, getReorderDragAPI, getSignupStatusAPI, getSingleLegalAPI, getStaticLegalAPI, IsheadingExistAPI, IsheadingExistBlogAPI, updateBlazeStatusApi, updateBlockReasonAPI, updateDisclaimerAPI, updateLegalAPI, updatePaymentPlatformStatusAPI, updateRefundDataAPI, updateSignupStatusAPI, updateStaticPageAPI, uploadImageAPI, uploadProductImageAPI } from '../apis/common'
import { deleteBannerAPI, getBannersListsAPI, getsingleBannerAPI, updateBannerListAPI } from "../../redux/apis/banners";
import { setData } from "utilities/common";
import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
import { getQueryString } from "utilities/common";

export const uploadImage = createAsyncThunk(
  'common/uploadImage',
  async (data, { rejectWithValue }) => {
    try {
      const res = await uploadImageAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const uploadProductImage = createAsyncThunk(
  'common/uploadProductImage',
  async (data, { rejectWithValue }) => {
    try {
      const res = await uploadProductImageAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchInfoEffect = createAsyncThunk(
  'common/fetchInfoEffect',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchInfoEffectsAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchCategories = createAsyncThunk(
  'common/fetchCategories',
  async (filters = { skip: 0, limit: 1000, userType: 'admin' }, { rejectWithValue }) => {
    try {
      const res = await fetchProductCategoriesAPI(filters);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchAllRegions = createAsyncThunk(
  'common/fetchAllRegions',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await fetchAllRegionsAPI(filters);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const bulkProductUpdate = createAsyncThunk(
  'common/bulkProductUpdate',
  async (data, { rejectWithValue }) => {
    try {
      const res = await BulkProductUpdateAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchSignupStatus = createAsyncThunk(
  'common/fetchSIngupStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getSignupStatusAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)
export const fetchRefundStatus = createAsyncThunk(
  'common/fetchRefundStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchRefundStatusAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)
export const updateRefundData = createAsyncThunk(
  'common/updateRefundData',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateRefundDataAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const updateSignupStatus = createAsyncThunk(
  'common/updateSignupStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateSignupStatusAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchPaymentPlatformStatus = createAsyncThunk(
  'common/fetchPaymentPlatformStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getPaymentPlatformStatusAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)
export const getBlazeStatus = createAsyncThunk(
  'common/getBlazeStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getBlazeStatusApi(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const updateBlazeStatus = createAsyncThunk(
  'common/updateBlazeStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateBlazeStatusApi(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const updatePaymentPlatformStatus = createAsyncThunk(
  'common/updatePaymentPlatformStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updatePaymentPlatformStatusAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const getHomepageBanners = createAsyncThunk(
  'common/getHomepageBanners',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getBannersListsAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const getHomePageEditData = createAsyncThunk(
  'common/getHomePageEditData',
  async (id, isDefaultHomePage, { rejectWithValue }) => {
    try {
      if (isDefaultHomePage) {

        const res = await getHomePageEditDataAPI();
        return
      }
      const res = await getHomePageEditDataAPI(id);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

// Home list data
export const getHomeList = createAsyncThunk(
  "api/v1/admin/home/page",
  async (data, { rejectWithValue }) => {
    try {
      const res = await getHomeList(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateHomePageBanners = createAsyncThunk(
  'common/updateHomePageBanners',
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const res = await updateBannerListAPI(data, id);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const getSingleBannerAPI = createAsyncThunk(
  'common/getSingleBannerAPI',
  async (id, { rejectWithValue }) => {
    try {
      const res = await getsingleBannerAPI(id);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const deleteBanner = createAsyncThunk(
  'common/deleteBanner',
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteBannerAPI(id);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const getProductDisclaimers = createAsyncThunk(
  'common/getProductDisclaimers',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getProductDisclaimersAPI();
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const updateDisclaimer = createAsyncThunk(
  'common/updateDisclaimer',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateDisclaimerAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchRefundList = createAsyncThunk(
  'common/fetchRefundList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchRefundListAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

// export const fetchRefundTable = createAsyncThunk(
//     'common/fetchRefundTable',
//     async ({data}, { rejectWithValue }) => {
//         try {
//             const res = await fetchRefundTableAPI(data);
//             return res
//         } catch (error) {             
//             return rejectWithValue(error.response?.data)
//         }
//     }
// )
export const fetchRefundTable = createAsyncThunk(
  'common/fetchRefundTable',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchRefundTableAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchWalletTable = createAsyncThunk(
  'common/fetchWalletTable',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchWalletTableAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)
export const addCommonReason = createAsyncThunk(
  'common/addCommonReason',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await addCommonReasonAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const editRefundReason = createAsyncThunk(
  'common/editRefundReason',
  async ({ data, reasonId }, { rejectWithValue }) => {
    try {
      const res = await editRefundReasonApi(data, reasonId);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)
export const deleteReason = createAsyncThunk(
  'common/deleteReason',
  async (reasonId, { rejectWithValue }) => {
    try {
      const res = await deleteReasonApi(reasonId);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)


export const editWalletReason = createAsyncThunk(
  'common/editWalletReason',
  async ({ data, reasonId }, { rejectWithValue }) => {
    try {
      const res = await editWalletReasonApi(data, reasonId);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const addWalletReason = createAsyncThunk(
  'common/addWalletReason',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await addWalletReasonAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchWalletReasonList = createAsyncThunk(
  'common/fetchWalletReasonList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchWalletReasonListAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)
export const deleteWalletReason = createAsyncThunk(
  'common/deleteWalletReason',
  async (reasonId, { rejectWithValue }) => {
    try {
      const res = await deleteWalletReasonApi(reasonId);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const getLegalList = createAsyncThunk(
  'common/getLegalList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getLegalListAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteLegal = createAsyncThunk(
  'common/deleteLegal',
  async ({ slug, platform }, { rejectWithValue }) => {
    try {
      const res = await deleteLegalAPI(slug, platform);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getStaticLegal = createAsyncThunk(
  'common/getStaticLegal',
  async ({ id, platform }, { rejectWithValue }) => {
    try {
      const res = await getStaticLegalAPI(id, platform);
      return res;
    } catch (error) {

      return rejectWithValue(error.response?.data);
    }
  }
);
export const getReorderDrag = createAsyncThunk(
  'common/getReorderDrag',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getReorderDragAPI(data);
      return res;
    } catch (error) {

      return rejectWithValue(error.response?.data);
    }
  }
);

export const IsheadingExist = createAsyncThunk(
  'common/IsheadingExist',
  async ({ platform, heading }, { rejectWithValue }) => {
    try {
      const res = await IsheadingExistAPI({ platform, heading });
      return res;
    } catch (error) {

      return rejectWithValue(error.response?.data);
    }
  }
);

export const IsheadingExistBlog = createAsyncThunk(
  'common/IsheadingExistBlog',
  async ({ platform, heading }, { rejectWithValue }) => {
    try {
      const res = await IsheadingExistBlogAPI({ platform, heading });
      return res;
    } catch (error) {

      return rejectWithValue(error.response?.data);
    }
  }
);


export const createStaticPage = createAsyncThunk(
  'common/createStaticPage',
  async (data, { rejectWithValue }) => {

    try {
      const res = await createStaticPageAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateStaticPage = createAsyncThunk(
  'common/updateStaticPage',
  async ({ data, id, platform }, { rejectWithValue }) => {

    try {
      const res = await updateStaticPageAPI(data, id, platform);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateBlockReason = createAsyncThunk(
  'common/updateBlockReason',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateBlockReasonAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
)

export const getBlockReason = createAsyncThunk(
  'common/getBlockReason',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getBlockReasonAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
)
export const BulkProductCategoriesUpdate = createAsyncThunk(
  'common/BulkProductCategoriesUpdate',
  async (data, { rejectWithValue }) => {
    try {
      const res = await BulkProductCategoriesUpdateApi(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchAIPrompt = createAsyncThunk(
  'common/fetchAIPrompt',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchAIPromptAPI(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const getMediaFromLibrary = createAsyncThunk(
  'common/getMediaFromLibrary',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getMediaFromLibraryApi(data);
      return res
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)
export const addProductCarousel = createAsyncThunk(
  'common/addProductCarousel',
  async ({ data, CarouselId }, { rejectWithValue }) => {
    try {
      const res = await addProductCarouselApi(data, CarouselId);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchCarouselIdProduct = createAsyncThunk(
  'common/fetchCarouselIdProduct',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchCarouselIdProductApi(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const assignProductsToCarousel = createAsyncThunk(
  'common/assignProductsToCarousel',
  async (data, { rejectWithValue }) => {
    try {
      const { carouselId, payload } = data || {}
      const res = await assignProductsToCarouselApi(carouselId, payload);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchProductDeatilsCarousel = createAsyncThunk(
  'common/fetchProductDeatilsCarousel',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchProductDeatilsCarouselApi(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)


const commonSlice = createSlice({
  name: 'common',
  initialState: {
    // Your initial state here
    isLoading: false,
    isdltLoading: false,
    isAssignCarouselLoading: false,
    infoEffectData: [],
    categoriesData: [],
    regions: [],
    fetchCategoriesError: null,
    isFetchingCategories: false,
    snackbar: {
      isOpen: false,
      color: '',
      icon: '',
      content: '',
      bgWhite: false,
      anchorOrigin: { vertical: "top", horizontal: "right" },
      persist: false,
    },
    isUploading: false,
    banners: {},
    paymentPlatformStatus: {},
    singleBanner: {},
    adminsMode: (() => {
      try {
        const stored = localStorage.getItem('adminsMode');
        return stored ? JSON.parse(stored) : 'hemp';
      } catch (e) {
        return 'hemp';
      }
    })(),
    isFullScreen: false,
    isGetLoading: false,
    isBtnLoading: false,
    loading: false,
    isgetLoading: false,
    blockReason: '',
    isupdateLoading: false
  },
  reducers: {
    setFullScreen: (state, action) => {
      state.isFullScreen = action.payload
    },
    openSnackbar: (state, action) => {
      state.snackbar.isOpen = true;
      state.snackbar.color = action.payload.color;
      state.snackbar.icon = action.payload.icon;
      state.snackbar.content = action.payload.content;
      state.snackbar.anchorOrigin = action.payload.anchorOrigin || { vertical: "top", horizontal: "right" };
      state.snackbar.persist = Boolean(action.payload.persist);
      // state.snackbar.bgWhite =( action.payload.color === 'error' || action.payload.color === 'success') ? false : true 
    },
    closeSnackbar: (state) => {
      state.snackbar.isOpen = false;
      // state.snackbar.color = '';
      // state.snackbar.icon = '';
      // state.snackbar.content = '';
      state.snackbar.bgWhite = false;
      state.snackbar.persist = false;
    },
    setAdminsMode: (state, action) => {
      state.adminsMode = action.payload
      setData('adminsMode', action.payload)
    },
    setSelectedDeliverySlot: (state, action) => {

      state.selectedDeliverySlot = action?.payload;
    },
    // Any other reducers you have
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInfoEffect.pending, (state, action) => {
      // Handle fetch errors
      state.isLoading = true
      state.fetchInfoEffectError = action.payload;
    });
    builder.addCase(fetchInfoEffect.fulfilled, (state, action) => {
      // Handle successful fetch of info effects
      state.infoEffectData = action.payload;
      state.isLoading = false
      state.fetchInfoEffectError = null;
    });
    builder.addCase(fetchInfoEffect.rejected, (state, action) => {
      // Handle fetch errors
      state.isLoading = false
      state.fetchInfoEffectError = action.payload;
    });

    builder.addCase(fetchCategories.pending, (state) => {
      // Set the pending state to true
      state.isFetchingCategories = true;
      state.fetchCategoriesError = null; // Reset any previous errors
    });
    builder.addCase(fetchCategories.fulfilled, (state, action) => {
      // Handle successful fetch of categories
      state.categoriesData = action.payload;
      state.fetchCategoriesError = null;
      state.isFetchingCategories = false; // Reset the pending state
    });
    builder.addCase(fetchCategories.rejected, (state, action) => {
      // Handle fetch errors
      state.fetchCategoriesError = action.payload;
      state.isFetchingCategories = false; // Reset the pending state
    });

    builder.addCase(fetchAllRegions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.regions = action.payload; // Update state with the received data
      state.error = null;
    });

    builder.addCase(fetchAllRegions.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload; // Update state with the error message
    });

    builder.addCase(fetchAllRegions.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(uploadImage.pending, (state) => {
      state.isUploading = true;
      state.error = null;
    })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.isUploading = false;
        // Assuming your API response contains the uploaded image URL
        state.imageUrl = action.payload;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.isUploading = false;
        state.error = action.payload;
      })

    builder.addCase(uploadProductImage.pending, (state) => {
      state.isUploading = true;
      state.error = null;
    })
      .addCase(uploadProductImage.fulfilled, (state, action) => {
        state.isUploading = false;
        // Assuming your API response contains the uploaded image URL
        state.imageUrl = action.payload;
      })
      .addCase(uploadProductImage.rejected, (state, action) => {
        state.isUploading = false;
        state.error = action.payload;
      })

    builder.addCase(bulkProductUpdate.pending, (state) => {
      state.isDeleting = true;
      state.error = null;
    })
      .addCase(bulkProductUpdate.fulfilled, (state) => {
        state.isDeleting = false;
        // Assuming your API response contains the uploaded image URL
      })
      .addCase(bulkProductUpdate.rejected, (state, action) => {
        state.isDeleting = false;
        state.error = action.payload;
      })

    builder
      .addCase(fetchSignupStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSignupStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.signupStatus = action.payload;
      })
      .addCase(fetchSignupStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchRefundStatus.pending, (state) => {
        state.isGetLoading = true;
        state.error = null;
      })
      .addCase(fetchRefundStatus.fulfilled, (state, action) => {
        state.isGetLoading = false;
        state.fetchRefund = action.payload;
      })
      .addCase(fetchRefundStatus.rejected, (state, action) => {
        state.isGetLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateRefundData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateRefundData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateRefundData = action.payload;
      })
      .addCase(updateRefundData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(updateSignupStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateSignupStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateSignupStatus.rejected, (state) => {
        state.isLoading = false;
      })
    builder
      .addCase(updateBlazeStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateBlazeStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateBlazeStatus.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getHomepageBanners.pending, (state) => {
        state.isLoading = true;
        state.singleBanner = {}
        state.error = null;
      })
    builder
      .addCase(getHomepageBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banners = action.payload;
      })
      .addCase(getHomepageBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getHomePageEditData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getHomePageEditData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.homePageEditData = action.payload;
      })
      .addCase(getHomePageEditData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updatePaymentPlatformStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePaymentPlatformStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updatePaymentPlatformStatus.rejected, (state) => {
        state.isLoading = false;
      })

    builder
      .addCase(fetchPaymentPlatformStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPaymentPlatformStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.paymentPlatformStatus = action.payload;
      })
      .addCase(fetchPaymentPlatformStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getBlazeStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBlazeStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blazeAPIEnabled = action.payload;
      })
      .addCase(getBlazeStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(updateBlockReason.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateBlockReason.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateBlockReason.rejected, (state) => {
        state.isLoading = false;
      })

    builder
      .addCase(getBlockReason.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBlockReason.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blockReason = action.payload;
      })
      .addCase(getBlockReason.rejected, (state) => {
        state.isLoading = false;
      })

    builder
      .addCase(getSingleBannerAPI.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSingleBannerAPI.fulfilled, (state, action) => {
        state.isLoading = false;
        state.singleBanner = action.payload;
      })
      .addCase(getSingleBannerAPI.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(deleteBanner.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteBanner.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getProductDisclaimers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProductDisclaimers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.disclaimers = action.payload;
      })
      .addCase(getProductDisclaimers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Something went wrong';
      });
    builder
      .addCase(updateDisclaimer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateDisclaimer.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateDisclaimer.rejected, (state) => {
        state.isLoading = false;
      });
    builder
      .addCase(fetchRefundList.pending, (state) => {
        state.isLoading = true;
        state.refundList = [];
      })
      .addCase(fetchRefundList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.refundList = action.payload;
      })
      .addCase(fetchRefundList.rejected, (state) => {
        state.isLoading = false;
        state.refundList = [];
      });
    builder
      .addCase(fetchRefundTable.pending, (state) => {
        state.tableloading = true;
        state.refundList = {};
      })
      .addCase(fetchRefundTable.fulfilled, (state, action) => {
        state.tableloading = false;
        state.refundList = action.payload;
      })
      .addCase(fetchRefundTable.rejected, (state) => {
        state.tableloading = false;
        state.refundList = {};
      });
    builder
      .addCase(addCommonReason.pending, (state) => {
        state.isBtnLoading = true;
      })
      .addCase(addCommonReason.fulfilled, (state) => {
        state.isBtnLoading = false;
      })
      .addCase(addCommonReason.rejected, (state) => {
        state.isBtnLoading = false;
      });
    builder
      .addCase(editRefundReason.pending, (state) => {
        state.isBtnLoading = true;
      })
      .addCase(editRefundReason.fulfilled, (state) => {
        state.isBtnLoading = false;
      })
      .addCase(editRefundReason.rejected, (state) => {
        state.isBtnLoading = false;
      });
    builder
      .addCase(deleteReason.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteReason.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteReason.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getLegalList.pending, (state) => {
        state.loading = true;

      })
      .addCase(getLegalList.fulfilled, (state, action) => {
        state.loading = false;
        state.legalList = action.payload;
      })
      .addCase(getLegalList.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(deleteLegal.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteLegal.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteLegal.rejected, (state) => {
        state.isLoading = false
      });


    builder
      .addCase(getStaticLegal.pending, (state) => {
        state.isLoading = true
        state.singleLegal = {}
      })
      .addCase(getStaticLegal.fulfilled, (state, action) => {
        state.isLoading = false
        state.singleLegal = action.payload.legalDetails
      })
      .addCase(getStaticLegal.rejected, (state) => {
        state.isLoading = false
      });



    builder
      .addCase(createStaticPage.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createStaticPage.fulfilled, (state) => {
        state.isLoading = false

      })
      .addCase(createStaticPage.rejected, (state) => {
        state.isLoading = false
      });
    builder
      .addCase(updateStaticPage.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateStaticPage.fulfilled, (state) => {
        state.isLoading = false

      })
      .addCase(updateStaticPage.rejected, (state) => {
        state.isLoading = false
      });
    builder
      .addCase(getReorderDrag.pending, (state) => {
        state.isgetLoading = true
      })
      .addCase(getReorderDrag.fulfilled, (state) => {
        state.isgetLoading = false

      })
      .addCase(getReorderDrag.rejected, (state) => {
        state.isgetLoading = false
      });

    builder
      .addCase(fetchWalletTable.pending, (state) => {
        state.tableloading = true;
        state.refundList = {};
      })
      .addCase(fetchWalletTable.fulfilled, (state, action) => {
        state.tableloading = false;
        state.refundList = action.payload;
      })
      .addCase(fetchWalletTable.rejected, (state) => {
        state.tableloading = false;
        state.refundList = {};
      });

    builder
      .addCase(editWalletReason.pending, (state) => {
        state.isBtnLoading = true;
      })
      .addCase(editWalletReason.fulfilled, (state) => {
        state.isBtnLoading = false;
      })
      .addCase(editWalletReason.rejected, (state) => {
        state.isBtnLoading = false;
      });
    builder
      .addCase(addWalletReason.pending, (state) => {
        state.isBtnLoading = true;
      })
      .addCase(addWalletReason.fulfilled, (state) => {
        state.isBtnLoading = false;
      })
      .addCase(addWalletReason.rejected, (state) => {
        state.isBtnLoading = false;
      });
    builder
      .addCase(deleteWalletReason.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteWalletReason.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteWalletReason.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(fetchWalletReasonList.pending, (state) => {
        state.isLoading = true;
        state.refundList = [];
      })
      .addCase(fetchWalletReasonList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.refundList = action.payload;
      })
      .addCase(fetchWalletReasonList.rejected, (state) => {
        state.isLoading = false;
        state.refundList = [];
      });
    builder
      .addCase(IsheadingExist.pending, (state) => {
        state.isgetLoading = true
      })
      .addCase(IsheadingExist.fulfilled, (state) => {
        state.isgetLoading = false

      })
      .addCase(IsheadingExist.rejected, (state) => {
        state.isgetLoading = false
      });
    builder
      .addCase(getMediaFromLibrary.pending, (state) => {
        state.isgetLoading = true
      })
      .addCase(getMediaFromLibrary.fulfilled, (state) => {
        state.isgetLoading = false

      })
      .addCase(getMediaFromLibrary.rejected, (state) => {
        state.isgetLoading = false
      });
    builder
      .addCase(addProductCarousel.pending, (state) => {
        state.isupdateLoading = true
      })
      .addCase(addProductCarousel.fulfilled, (state) => {
        state.isupdateLoading = false

      })
      .addCase(addProductCarousel.rejected, (state) => {
        state.isupdateLoading = false
      });
    builder
      .addCase(fetchCarouselIdProduct.pending, (state) => {
        state.isgetLoading = true
      })
      .addCase(fetchCarouselIdProduct.fulfilled, (state) => {
        state.isgetLoading = false

      })
      .addCase(fetchCarouselIdProduct.rejected, (state) => {
        state.isgetLoading = false
      });
    builder
      .addCase(assignProductsToCarousel.pending, (state) => {
        state.isAssignCarouselLoading = true
      })
      .addCase(assignProductsToCarousel.fulfilled, (state) => {
        state.isAssignCarouselLoading = false
      })
      .addCase(assignProductsToCarousel.rejected, (state) => {
        state.isAssignCarouselLoading = false
      });
    builder
      .addCase(fetchProductDeatilsCarousel.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchProductDeatilsCarousel.fulfilled, (state) => {
        state.isLoading = false

      })
      .addCase(fetchProductDeatilsCarousel.rejected, (state) => {
        state.isLoading = false
      });
  },


});

// Other slice configuration code...
export const { openSnackbar, closeSnackbar, setSelectedDeliverySlot, setAdminsMode, setFullScreen } = commonSlice.actions;
export default commonSlice.reducer;